<template>
  <content-dialog
    v-model="dialogOpen"
    fullscreen-mobile
    no-backdrop-dismiss
    flex
    width="640px"
    height="70vh"
    :title="title"
  >
    <TemplateEditor
      ref="editor"
      @saved="onSaved"
      @cancel="dialogOpen = false"
      @title-change="title = $event"
    />
  </content-dialog>
</template>

<script>
import TemplateEditor from './TemplateEditor'

/*
  Thin dialog wrapper around TemplateEditor for hosts that aren't already a
  dialog suited to view-swapping (e.g. the checklist picker on appointment
  types). The Checklist Templates settings dialog embeds TemplateEditor
  directly instead.
*/
export default {
  components: {
    TemplateEditor
  },
  emits: ['saved'],
  data () {
    return {
      dialogOpen: false,
      title: 'Add Checklist Template'
    }
  },
  methods: {
    open (template) {
      this.dialogOpen = true
      this.$nextTick(() => {
        this.$refs.editor.reset(template)
      })
    },
    onSaved (payload) {
      this.$emit('saved', payload)
      this.dialogOpen = false
    }
  }
}
</script>
